class MCImageCarousel {
  constructor(element) {
    this.carousel = element;
    this.container = element.querySelector(
      ".mc-image-carousel__slider-container"
    );
    this.slides = element.querySelectorAll(".mc-image-carousel__slide");
    this.prevBtn = element.querySelector(".mc-image-carousel__nav--prev");
    this.nextBtn = element.querySelector(".mc-image-carousel__nav--next");
    this.dots = element.querySelectorAll(".mc-image-carousel__dot");

    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.isAutoplay = false;
    this.autoplayInterval = null;
    this.touchStartX = 0;
    this.touchEndX = 0;

    this.init();
  }

  init() {
    if (this.totalSlides <= 1) return;

    this.setupEventListeners();
    this.setupAutoplay();
    this.setupTouchEvents();
    this.setupKeyboardNavigation();
    this.updateSlidePosition();
    this.updateDots();
  }

  setupEventListeners() {
    // Navigation arrows
    this.prevBtn?.addEventListener("click", () => this.previousSlide());
    this.nextBtn?.addEventListener("click", () => this.nextSlide());

    // Dots navigation
    this.dots.forEach((dot, index) => {
      dot.addEventListener("click", () => this.goToSlide(index));
    });

    // Pause autoplay on hover
    this.carousel.addEventListener("mouseenter", () => this.pauseAutoplay());
    this.carousel.addEventListener("mouseleave", () => this.resumeAutoplay());
  }

  setupAutoplay() {
    const autoplayEnabled = this.carousel.dataset.autoplay === "true";
    const autoplaySpeed = parseInt(this.carousel.dataset.autoplaySpeed) || 5;

    if (autoplayEnabled) {
      this.isAutoplay = true;
      this.startAutoplay(autoplaySpeed * 1000);
    }
  }

  setupTouchEvents() {
    this.carousel.addEventListener("touchstart", (e) => {
      this.touchStartX = e.changedTouches[0].screenX;
    });

    this.carousel.addEventListener("touchend", (e) => {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
    });
  }

  setupKeyboardNavigation() {
    this.carousel.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        this.previousSlide();
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        this.nextSlide();
      }
    });
  }

  handleSwipe() {
    const swipeThreshold = 50;
    const swipeDistance = this.touchEndX - this.touchStartX;

    if (Math.abs(swipeDistance) > swipeThreshold) {
      if (swipeDistance > 0) {
        this.previousSlide();
      } else {
        this.nextSlide();
      }
    }
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    this.updateSlidePosition();
    this.updateDots();
  }

  previousSlide() {
    this.currentSlide =
      (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    this.updateSlidePosition();
    this.updateDots();
  }

  goToSlide(index) {
    this.currentSlide = index;
    this.updateSlidePosition();
    this.updateDots();
  }

  updateSlidePosition() {
    const translateX = -this.currentSlide * 100;
    this.container.style.transform = `translateX(${translateX}%)`;
  }

  updateDots() {
    this.dots.forEach((dot, index) => {
      dot.classList.toggle(
        "mc-image-carousel__dot--active",
        index === this.currentSlide
      );
    });
  }

  startAutoplay(interval) {
    this.autoplayInterval = setInterval(() => {
      this.nextSlide();
    }, interval);
  }

  pauseAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  resumeAutoplay() {
    if (this.isAutoplay && !this.autoplayInterval) {
      const autoplaySpeed = parseInt(this.carousel.dataset.autoplaySpeed) || 5;
      this.startAutoplay(autoplaySpeed * 1000);
    }
  }

  destroy() {
    this.pauseAutoplay();
    // Remove event listeners would go here if needed
  }
}

// Initialize carousels when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll(".mc-image-carousel");
  carousels.forEach((carousel) => {
    // Get settings from liquid section
    const autoplay =
      carousel.closest(".section-mc-image-carousel")?.dataset.autoplay ===
      "true";
    const autoplaySpeed =
      carousel.closest(".section-mc-image-carousel")?.dataset.autoplaySpeed ||
      5;

    carousel.dataset.autoplay = autoplay;
    carousel.dataset.autoplaySpeed = autoplaySpeed;

    new MCImageCarousel(carousel);
  });
});

// Handle theme editor updates
document.addEventListener("shopify:section:load", (event) => {
  const carousel = event.target.querySelector(".mc-image-carousel");
  if (carousel) {
    new MCImageCarousel(carousel);
  }
});

// Export for potential external use
window.MCImageCarousel = MCImageCarousel;
